import { Handle, NodeProps, Position } from 'reactflow';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';

import { useGlobalStyles, translateKey } from './base.node';
import { CustomNodeMenu } from './base.nodemenu';

/*
  DefineStringArray react-flow node for module builder graph canvas
*/

export const DefineStringArrayNode: React.FC<NodeProps<any>> = (
  nodeProps: any
) => {
  const classes = useGlobalStyles();
  const intl = useIntl();

  //const stringArrayMesssage = 'hallo';

  const stringArrayMesssage = intl.formatMessage({
    id: 'builder.nodes.elements.defineStringArray.hint',
    defaultMessage:
      'Dieser Knoten definiert eine Liste von Wörtern und wird nicht im Chat angezeigt. Name: ',
  });

  const testListHint = intl.formatMessage({
    id: 'builder.nodes.elements.defineStringArray.listhint',
    defaultMessage: 'Die Wörter in der Liste lauten:',
  });

  const payload = nodeProps.data.state.entry[0].payload;

  const translatedLabels = payload.labels
    ? payload.labels.map((label: string) => translateKey(intl, label))
    : [''];

  return (
    <>
      <Handle
        type="target"
        id="definestringarrayin"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={
          nodeProps.selected
            ? classes.controlelementstyleselected
            : classes.controlelementstyle
        }
        style={{ width: '300px' }}
      >
        <CustomNodeMenu nodeid={nodeProps.id} />
        <Typography component="span">
          {stringArrayMesssage}
          <strong>
            {(payload.saveResultTo + '').startsWith('evoachechokey')
              ? ''
              : payload.saveResultTo}
          </strong>
          <br />
          {testListHint}
          <br />
          <ol>
            {translatedLabels.map((label: string, index: number) => (
              <li key={'label' + index}>{label}</li>
            ))}
          </ol>
        </Typography>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="defineStringArrayhandle"
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
    </>
  );
};
